jQuery(document).ready(function($){

    $('body').on('click', '.View--More-Link', function() {
        $(this).removeClass('View--More-Link').addClass('View--Less-Link');
        $(this).closest('.Rte').find('.Rte-less').hide();
        $(this).closest('.Rte').find('.Rte-full').show();
        $(this).text('Less');
    });

    $('body').on('click', '.View--Less-Link', function() {
        $(this).removeClass('View--Less-Link').addClass('View--More-Link');
        $(this).closest('.Rte').find('.Rte-full').hide();
        $(this).closest('.Rte').find('.Rte-less').show();
        $(this).text('More');
    });
  
});